export const pageSizes = [
  { name: '8.3x11.7 inches (A4)', width: 794, height: 1123 },
  { name: '8.5x11 inches (Letter)', width: 612, height: 792 },
  { name: '8.5x14 inches (Legal)', width: 612, height: 1008 },
  { name: '11x17 inches (Tabloid)', width: 792, height: 1224 },
  { name: '9.8x13 inches (B4)', width: 850, height: 1204 },
  { name: '7.3x10.1 inches (B5)', width: 600, height: 850 },
  { name: '7.75x10.5 inches (Executive)', width: 522, height: 756 },
  { name: '8.27x13.9 inches (Folio)', width: 612, height: 936 }

  // Add more page sizes as needed
];
